// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4WVMK","title":"styles_title__e_CFb"};